import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
import { MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { Timestamp } from 'firebase/firestore'; 
import { Prontofibra_Firestore } from "src/app/models/prontofibra.firestore.model";
import { ProntofibraService } from "src/app/services/prontofibra.service";
import { ListeService } from "src/app/services/liste.service";
import { ProntofibraDTO } from "src/app/models/prontofibra.dto.model";
import { CategoriaKOProntofibraDTO } from "src/app/models/prontofibra.categoriaAttesa.model";
import { StiliService } from "src/app/services/stili.service";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { CategoriaVincolo } from "src/app/models/categoriaVincolo.model";
import { UtilService } from "src/app/services/util.service";
import { PraticheService } from "src/app/services/pratiche.service";
  

@Component({
    selector: "component_modifica_vincolo",
    templateUrl: "./dialog-modifica_vincolo.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogModificaVincolo implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected modificaVincoloForm: FormGroup;
    protected isModificandoVincolo:boolean = false;
    protected categorieVincolo:CategoriaVincolo[]=[];
    protected categorieVincoloFiltrate:CategoriaVincolo[]=[];

    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private formBuilder: FormBuilder,
      private utilService:UtilService,
      private messageService: MessageService,
      public listeService:ListeService,
      protected stiliService:StiliService,
      private praticheService:PraticheService,
    ) {
      this.pratica          = this.config.data.pratica;
     
      this.loadCategorieVincolo();
      
    }
    loadCategorieVincolo() {
      this.utilService.getTipologieVincolo().subscribe((categorieVincolo) => {
        this.logger.info("DENTRO LOAD CATEGORIE VINCOLO");
       
        this.categorieVincolo = categorieVincolo;
        this.categorieVincoloFiltrate = this.categorieVincolo.filter(
          categoria => categoria.tipologiaVincolo.id === this.pratica.vincoloTipologiaID
        );
        //this.categorieVincoloFiltrate = [...this.categorieVincolo];
        const categoriaVincolo = this.categorieVincoloFiltrate.find(
          (item) => item.codice === this.pratica.vincoloCategoriaCodice
        );
        
        if (categoriaVincolo) {
          this.modificaVincoloForm.patchValue({
            categoria: categoriaVincolo
          });
        }
      });
    }
    ngOnInit() {
      this.logger.info("ON INIT");
      this.prepareForm();
     
    }

    prepareForm(){
      this.logger.info("Preparazione form con pratica:", this.pratica);
      
      const tipoVincolo = this.listeService.tipologieVincolo.find(
        (item) => item.value === this.pratica.vincoloTipologiaID
      )?.value;

      

      
      this.modificaVincoloForm = this.formBuilder.group({
        tipo: [tipoVincolo, [Validators.required]],
        categoria: [null, [Validators.required]]
      });

      // Aggiungo il listener per il cambio del tipo di vincolo
      this.modificaVincoloForm.get('tipo').valueChanges.subscribe((nuovoTipo) => {
        if (nuovoTipo) {
          this.logger.info("Tipo vincolo cambiato a "+nuovoTipo + ", azzeramento categoria");
          this.modificaVincoloForm.patchValue({
            categoria: null
          });
          // Filtro le categorie in base al tipo selezionato
          this.categorieVincoloFiltrate = this.categorieVincolo.filter(
            categoria => categoria.tipologiaVincolo.id === nuovoTipo
          );
          this.logger.info("Categorie filtrate per tipo " + nuovoTipo + ": ", this.categorieVincoloFiltrate);
        } else {
          // Se non c'è tipo selezionato, mostro tutte le categorie
          this.categorieVincoloFiltrate = [...this.categorieVincolo];
        }
      });

      // Se abbiamo trovato una categoria, impostiamo il valore nel form
      
    }
    private convertFirestoreTimestampToDate(timestamp: Timestamp): Date {
      return timestamp.toDate();
    }
  
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.isModificandoVincolo = true;
        this.logger.info(this.modificaVincoloForm.get('categoria').value);
        let nuovaCategoria:CategoriaVincolo = this.modificaVincoloForm.get('categoria').value;
        this.praticheService.modificaCategoriaKO(this.pratica.id, nuovaCategoria).subscribe( {
          next: (res) => {
            this.isModificandoVincolo = false;
            this.dialogRef.close({ success: true});
          }, error: (e) => {
            this.isModificandoVincolo = false;
            this.messageService.add({
              severity: "info",
              summary: "Errore" , life:10000,
                detail: "Errore in fase di modifica della categoria del vincolo!",
              });
            this.dialogRef.close({ success: false });
          },
          complete: () => {

          }
        });

        /* let pfDaAggiornare:ProntofibraDTO = new ProntofibraDTO();
        if(this.modificaVincoloForm.get('note').value){
          pfDaAggiornare.noteKO = this.modificaVincoloForm.get('note').value;
        }
        let categoriaAttesa:CategoriaKOProntofibraDTO = new CategoriaKOProntofibraDTO();
        categoriaAttesa.id = this.modificaVincoloForm.get('categoria').value;
        pfDaAggiornare.categoriaKO = categoriaAttesa;
         this.pfService.modificaCategoriaKO(this.pratica.id, pfDaAggiornare).subscribe( {
            next: (res) => {
              this.isModificandoVincolo = false;
              this.dialogRef.close({ success: true});
            },  error: (e) => {
              this.isModificandoVincolo = false;
              this.messageService.add({
                severity: "info",
                summary: "Errore" , life:10000,
                  detail: "Errore in fase di modifica della categoria di attesa del PF!",
                });
              this.dialogRef.close({ success: false });
            },
            complete: () => {

            }
          }
        ); */
        }  
      } 
    
  }